import BackPrevention from './detect-back-button.js';
import runDiscountTimer from './timer.js';

export default function ({popupID, delay = 60, extraDelayTime = 20, maxAttempts = 2, offerTimer = 120, overflowHidden = true, blockedPopupId = null, leaveFromTop = true}) {
    if (!popupID) return

    const exitPopEl = document.getElementById(popupID);
    if (!exitPopEl) return

    const isMobile = window.innerWidth <= 768;
    const body = document.querySelector('body');
    const blockedPopupEl = blockedPopupId && document.getElementById(blockedPopupId)
    let delayTime = delay; //in seconds
    let backButtonBlocker
    let discountTimer;
    let popupAttemptsCounter = 0

    const toggleModalActiveState = () => {
        if (!exitPopEl.classList.contains('active')) {
            // 🔔 Dispatch a custom event
            window.dispatchEvent(new CustomEvent('popup:show'))
        }
        exitPopEl.classList.toggle('active');
        if (overflowHidden) body.style.overflow = exitPopEl.classList.contains('active') ? 'hidden' : 'hidden auto'
    };

    const scrollToVideo = () => {
        const orientation = window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';
        const videoEl = document.querySelector(`.video.${orientation}`);

        if (!videoEl) return;

        if ('scrollBehavior' in document.documentElement.style) {
            videoEl.scrollIntoView({behavior: 'smooth', block: 'center'});
        } else {
            videoEl.scrollIntoView(false);
        }
    };

    const handleModalClick = (e) => {
        if (!e.target.matches('.close-modal')) return;

        e.preventDefault();

        if (discountTimer) {
            discountTimer.pause();
        }

        toggleModalActiveState();

        if (e.target.classList.contains('with-scroll')) {
            scrollToVideo();
        }

        if (!document.getElementById(popupID)) {
            maxAttempts = 1
        }
    };

    exitPopEl.addEventListener('click', handleModalClick, false);

    const activateExitPopup = () => {
        if(blockedPopupEl && blockedPopupEl.classList.contains('active')) {
            return
        }
        if (isMobile) {
            backButtonBlocker.deactivate()
        } else {
            document.removeEventListener('mouseout', handleMouseLeave);
        }

        if (popupAttemptsCounter >= maxAttempts) return

        if (!exitPopEl.classList.contains('active')) {
            toggleModalActiveState();
            if (!overflowHidden) {
                requestAnimationFrame(() => {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                });
            }

            if (!discountTimer) {
                discountTimer = runDiscountTimer(exitPopEl.querySelector('.timer'), offerTimer);
            } else {
                discountTimer.resume()
            }
            popupAttemptsCounter++
        }

        activateExitPopFeatures(extraDelayTime)
    }

    const handleMouseLeave = (event) => {
        const isMouseLeaving = event.clientY <= 0 || event.clientX <= 0 || event.clientX >= window.innerWidth || event.clientY >= window.innerHeight;

        if (leaveFromTop && event.clientY <= 0) {
            activateExitPopup();
        } else if (!leaveFromTop && isMouseLeaving) {
            activateExitPopup();
        }
    };

    const initBackButtonFeature = function () {
        backButtonBlocker = new BackPrevention({
            onBackAttempt: activateExitPopup
        });
        backButtonBlocker.activate();
    };

    const activateExitPopFeatures = (delay) => {
        setTimeout(() => {
            if (!exitPopEl) {
                return
            }

            if (isMobile) {
                initBackButtonFeature()
            } else {
                document.addEventListener('mouseout', handleMouseLeave)
            }
        }, 1000 * delay)
    }

    const deactivate = () => {
        // Remove all event listeners
        exitPopEl.removeEventListener('click', handleModalClick);

        if (backButtonBlocker) {
            backButtonBlocker.deactivate();
        }
        document.removeEventListener('mouseout', handleMouseLeave);

        if (discountTimer) {
            discountTimer.stop();
        }

        // Hide the popup if it's active
        if (exitPopEl.classList.contains('active')) {
            exitPopEl.classList.remove('active');
            body.style.overflow = 'hidden auto'
        }
    }


    activateExitPopFeatures(delayTime);

    return {
        deactivate
    }
}